import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M18 12a6 6 0 1 0-6.937 5.927v-4.193H9.539V12h1.524v-1.322c0-1.504.895-2.334 2.266-2.334.656 0 1.343.117 1.343.117v1.476h-.757c-.745 0-.977.463-.977.938V12h1.664l-.267 1.734h-1.398v4.193A6 6 0 0 0 18 12"
    }, null, -1)
  ])))
}
export default { render: render }